import { Container, IDestroyOptions, Point, Sprite, Text, TextStyle, Texture } from "pixi.js";
import { StealResourcePackage } from "../resources/StealResourcePackage";
import { ICanvasScaler } from "../../../../../canvas/ICanvasScaler";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { StealCard } from "../../../game/flow/impl/diceActions/stealAction/StealCard";
import { GameFont } from "../../../common/GameFont";
import { StringFormatExtention } from "../../../../../extensions/StringFormatExtention";
import { Avatar } from "../../../common/components/Avatar";
import { UserProfileResourcePackage } from "../../userprofile/resources/UserProfileResourcePackage";

export class Card extends Container {
    private static readonly DEFAULT_fIRST_NAME = "Jhon J.";
    private static readonly DEFAULT_LEVEL = "Lv.4";
    private static readonly DEFAULT_REWARD_VALUE = 1000;
    private static readonly REWARD_ICON_DEFAULT_SCALE = 0.8;

    private readonly stealResources: StealResourcePackage;
    private readonly commonResources: CommonResourcesPackage;
    private readonly userProfileResources: UserProfileResourcePackage;
    protected readonly canvasScaler: ICanvasScaler;
    private cardBackground: Sprite;
    private avatar: Avatar;
    private firstName: Text;
    private level: Text;
    private rewardCount: Text;
    private rewardIcon: Sprite;

    public constructor(stealResources: StealResourcePackage,
        commonResources: CommonResourcesPackage,
        userProfileResources: UserProfileResourcePackage,
        canvasScaler: ICanvasScaler
    ) {
        super();
        this.stealResources = stealResources;
        this.commonResources = commonResources;
        this.userProfileResources = userProfileResources;
        this.canvasScaler = canvasScaler;
        this.build();
        this.once("added", this.hideCardContent.bind(this));
    }

    private build(): void {
        this.cardBackground = new Sprite(this.stealResources.assets_views_steal_popup_card_back_side_png);
        this.cardBackground.anchor.set(0.5, 0.5);
        this.addChild(this.cardBackground);
        this.firstName = new Text(Card.DEFAULT_fIRST_NAME, new StealNameTextStyle());
        this.firstName.anchor.set(0.5, 0.5);
        this.addChild(this.firstName);
        this.avatar = new Avatar(this.userProfileResources, this.stealResources.assets_views_steal_popup_profile_icon_png);
        this.avatar.avatarSize = new Point(155, 155);
        this.avatar.position.set(-this.avatar.width * 0.5, -183);
        this.avatar.glow = true;
        this.addChild(this.avatar);
        this.level = new Text(Card.DEFAULT_LEVEL, new LevelTextStyle());
        this.level.anchor.set(0.5, 0.5);
        this.level.angle = -5;
        this.level.position.y = this.firstName.y + this.level.height * 0.4 + this.firstName.height * 0.5;
        this.addChild(this.level);
        this.rewardCount = new Text(Card.DEFAULT_REWARD_VALUE, new RewardValueTextStyle());
        this.rewardCount.anchor.set(0.5, 0.5);
        this.rewardCount.position.y = this.level.y + this.rewardCount.height * 0.5 + this.level.height * 0.5 + 10;
        this.rewardCount.position.x = this.level.x - this.rewardCount.width * 0.3;
        this.addChild(this.rewardCount);
        this.rewardIcon = new Sprite(this.commonResources.assets_common_ui_top_panel_coin_png);
        this.rewardIcon.scale.set(Card.REWARD_ICON_DEFAULT_SCALE, Card.REWARD_ICON_DEFAULT_SCALE);
        this.rewardIcon.anchor.set(0.5, 0.5);
        this.rewardIcon.position.y = this.rewardCount.position.y - 5;
        this.rewardIcon.position.x = this.rewardCount.x + this.rewardCount.width * 0.5 + this.rewardIcon.width * 0.6;
        this.addChild(this.rewardIcon);
    }

    private hideCardContent(): void {
        this.avatar.visible = false;
        this.firstName.visible = false;
        this.level.visible = false;
        this.rewardCount.visible = false;
        this.rewardIcon.visible = false;
    }

    public updateAndShowCardContent(stealCardData: StealCard, avatarTexture: Texture): void {
        this.avatar.updateTexture(avatarTexture);
        this.avatar.visible = true;
        this.firstName.text = stealCardData.guest.firstName.toUpperCase();
        this.firstName.visible = true;
        this.level.text = `Lv.${stealCardData.guest.level}`;
        this.level.visible = true;
        this.rewardCount.text = StringFormatExtention.formatWithComma(stealCardData.stealAmountInCoins);
        this.rewardIcon.position.x = this.rewardCount.x + this.rewardCount.width * 0.5 + this.rewardIcon.width * 0.6;
        this.rewardCount.visible = true;
        this.rewardIcon.visible = true;
        this.cardBackground.texture = stealCardData.willBeChosen ? this.stealResources.assets_views_steal_popup_card_bg_light_png : this.stealResources.assets_views_steal_popup_card_bg_png;
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        super.destroy(options);
    }
}

class LevelTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            dropShadow: true,
            dropShadowAlpha: 0.4,
            dropShadowAngle: 0,
            dropShadowBlur: 2,
            dropShadowDistance: 2,
            fill: "#ebc12f",
            fontFamily: "COMICZ",
            fontSize: 40
        }));
    }
}

class StealNameTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            dropShadow: true,
            dropShadowAngle: 0.5,
            dropShadowBlur: 3,
            dropShadowDistance: 2,
            align: "center",
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 42
        }));
    }
}

class RewardValueTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            fill: "#ebc12f",
            align: "center",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 82
        }));
    }
}
